import { t } from 'i18next'
import styled from 'styled-components'

const StyledContainer = styled.div`
  padding: 8px;
  width: 240px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  border-radius: 6px;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,
    rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
  &.yellow {
    .card-money-value {
      color: var(--color-yellow-106);
    }
  }
  &.blue {
    .card-money-value {
      color: var(--color-blue-107);
    }
  }
  &.red {
    .card-money-value {
      color: var(--color-red-107);
    }
  }
  &.green {
    .card-money-value {
      color: var(--color-primary-109);
    }
  }
  &.orange {
    .card-money-value {
      color: var(--color-orange-107);
    }
  }
`
const StyleTitle = styled.div`
  color: var(--color-gray-108);
  font-weight: 500;
  font-size: 1.4rem;
  text-transform: uppercase;
`
const StyleValue = styled.div`
  color: var(--color-gray-108);
  font-weight: 500;
  font-size: 2rem;
  text-transform: uppercase;
`

interface IProps {
  label?: string
  value?: string | number
  color?: 'yellow' | 'blue' | 'green' | 'red' | 'orange'
}

const CardMoney = (props: IProps) => {
  const { label, value, color } = props

  return (
    <StyledContainer className={color}>
      <StyleTitle>{t(label || '')}</StyleTitle>
      <StyleValue className="card-money-value">{value}</StyleValue>
    </StyledContainer>
  )
}

export default CardMoney
